import React from 'react'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'

function Layout() {
    return (
        <div className="min-h-screen flex flex-col" style={{ background: '#f4f6f9' }}>
            <Navbar />
            <main className="flex-1 w-full">
                <Outlet />
            </main>
        </div>
    )
}

export default Layout
